import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import TalksListItem from './TalksListItem';
import { showAllSpeakers, locations, locationBoth } from '../../util/locations';

const TalksList = ({ location, avatarPlaceholder }) => {
  const data = useStaticQuery(
    graphql`
      query {
        allPretalxSubmission(filter: {state: {eq: "confirmed"}, submission_type: {en: {eq: "Talk"}}}) {
          edges {
            node {
              id
              #slot {
              #  start
              #  end
              #  room {
              #    en
              #  }
              #}
              path
              tags
              title
              description
              abstract {
                childMarkdownRemark {
                  html
                }
              }
              submission_type {
                en
              }
              speakers {
                pretalxSpeaker {
                  name
                  id
                  path
                  localFile {
                    childImageSharp {
                      gatsbyImageData(height: 500, width: 500)
                    }
                  }
                }
              }
              answers {
                answer
                question {
                  question {
                    en
                  }
                }
              }
            }
          }
        }
      }
    `
  );

  const [talks, setTalks] = useState([]);

  useEffect(() => {
    if (!data) {
      return;
    }

    const allTalks = data.allPretalxSubmission.edges.map(({ node }) => node);
    const chosenLocationQ = 'Which event is this chosen for?';
    allTalks.forEach((t) => {
      t.answers.forEach(({ question, answer }) => {
        if (question.question.en === chosenLocationQ && locations.includes(answer)) {
          t.location = answer;
        }
      });
      // const talkDateString = t.slot.startTime.toLocaleString(
      //   'en-GB',
      //   { dateStyle: 'short', timeStyle: 'short' }
      // );
    });

    const filteredTalks = allTalks.filter((t) => {
      if (!location || location === showAllSpeakers || t?.location === locationBoth) {
        return true;
      }
      return t?.location === location;
    });
              // .filter((t) => !!t.slot?.startTime)
              // .sort((a, b) => a.slot.startTime - b.slot.startTime)

    setTalks(filteredTalks);
  }, [data, location]);

  if (!talks.length) {
    return <></>;
  }

  return (
    <div id="rs-blog" className="rs-blog blog-main-home home-6-blog-style bg27 pt-110 pb-120 md-pt-70 md-pb-80">
      <div className="container">
        <div>
          {talks.map((talk) => (
            <TalksListItem
              key={talk.id}
              talk={talk}
              avatarPlaceholder={avatarPlaceholder}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TalksList;
